<div class="card main-card mb-3">
    <div class="card-header">
        Profile updates
    </div>
    <div class="card-body">
        <canvas baseChart
            [data]="chartData"
            [labels]="chartLabels"
            [options]="chartOptions"
            [legend]="chartLegend"
            [chartType]="chartType">
        </canvas>
    </div>
</div>

